import { createRouter, createWebHistory } from 'vue-router';

import { frontendURL } from '../helper/URLHelper';
import dashboard from './dashboard/dashboard.routes';
import store from 'dashboard/store';
import { validateLoggedInRoutes } from '../helper/routeHelpers';
import { isOnOnboardingView } from 'v3/helpers/RouteHelper';
import AnalyticsHelper from '../helper/AnalyticsHelper';

const ONBOARDING_STEPS = ['account_details', 'enrichment', 'inbox_setup'];
const routes = [...dashboard.routes];

const onboardingPath = step =>
  step === 'inbox_setup' ? 'onboarding/inbox-setup' : 'onboarding';

export const router = createRouter({ history: createWebHistory(), routes });

export const validateAuthenticateRoutePermission = async (to, next) => {
  const { isLoggedIn, getCurrentUser: user } = store.getters;

  if (!isLoggedIn) {
    window.location.assign('/app/login');
    return '';
  }

  const { accounts = [], account_id: accountId } = user;

  if (!accounts.length) {
    if (to.name === 'no_accounts') {
      return next();
    }
    return next(frontendURL('no-accounts'));
  }

  const routeAccountId = Number(to.params?.accountId || accountId);
  const userAccount = accounts.find(a => a.id === routeAccountId);
  const isAdmin = userAccount?.role === 'administrator';
  const isActive = userAccount?.status === 'active';
  const needsOnboarding =
    ONBOARDING_STEPS.includes(userAccount?.onboarding_step) &&
    isAdmin &&
    isActive;

  if (to.name === 'no_accounts' || !to.name) {
    const target = needsOnboarding
      ? onboardingPath(userAccount?.onboarding_step)
      : 'dashboard';
    return next(frontendURL(`accounts/${routeAccountId}/${target}`));
  }

  if (needsOnboarding && !isOnOnboardingView(to)) {
    return next(
      frontendURL(
        `accounts/${routeAccountId}/${onboardingPath(userAccount?.onboarding_step)}`
      )
    );
  }
  if (!needsOnboarding && isOnOnboardingView(to)) {
    return next(frontendURL(`accounts/${routeAccountId}/dashboard`));
  }

  const nextRoute = validateLoggedInRoutes(to, store.getters.getCurrentUser);
  return nextRoute ? next(frontendURL(nextRoute)) : next();
};

export const getRouteTitle = to => {
  const name = String(to?.name || '');
  const path = String(to?.path || '');

  if (name === 'dashboard' || name === 'operations_overview' || path.endsWith('/dashboard')) {
    return 'Overview | Stampnexa Support';
  }
  if (name.includes('conversation') || path.includes('/conversations')) {
    return 'Conversations | Stampnexa Support';
  }
  if (name.includes('portal') || name.includes('article') || name.includes('category') || path.includes('/portals') || path.includes('/help-center')) {
    return 'Help Center | Stampnexa Support';
  }
  if (name.includes('contact') || path.includes('/contacts')) {
    return 'Contacts | Stampnexa Support';
  }
  if (name.includes('campaign') || path.includes('/campaigns')) {
    return 'Campaigns | Stampnexa Support';
  }
  if (name.includes('report') || path.includes('/reports')) {
    return 'Reports | Stampnexa Support';
  }
  if (name.includes('setting') || name.includes('agent') || name.includes('inbox') || name.includes('team') || name.includes('billing') || path.includes('/settings')) {
    return 'Settings | Stampnexa Support';
  }
  if (name.includes('notification') || path.includes('/notifications')) {
    return 'Notifications | Stampnexa Support';
  }
  if (name.includes('call') || path.includes('/calls')) {
    return 'Voice & Calls | Stampnexa Support';
  }
  if (name.includes('captain') || path.includes('/captain')) {
    return 'AI Automation | Stampnexa Support';
  }
  if (name.includes('company') || path.includes('/companies')) {
    return 'Companies | Stampnexa Support';
  }

  return 'Stampnexa Support Console';
};

export const initalizeRouter = () => {
  const userAuthentication = store.dispatch('setUser');

  router.beforeEach(async (to, _from, next) => {
    AnalyticsHelper.page(to.name || '', {
      path: to.path,
      name: to.name,
    });

    await userAuthentication;
    await validateAuthenticateRoutePermission(to, next, store);
  });

  router.afterEach(to => {
    document.title = getRouteTitle(to);
  });
};

export default router;

